import { IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  gridDetailPanelExpandedRowsContentCacheSelector,
  GridRenderCellParams,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { isValidElement } from 'react';

export function CustomDetailPanelToggle(
  props: Pick<GridRenderCellParams, 'id' | 'value'>,
) {
  const { id, value: isExpanded } = props;
  const apiRef = useGridApiContext();
  // To avoid calling ´getDetailPanelContent` all the time, the following selector
  // gives an object with the detail panel content for each row id.
  const contentCache = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowsContentCacheSelector,
  );
  // If the value is not a valid React element, it means that the row has no detail panel.
  const hasDetail = contentCache
    ? isValidElement(contentCache[id as string])
    : false;

  return (
    <IconButton
      size="medium"
      tabIndex={-1}
      hidden={!hasDetail}
      disabled={false}
      aria-label={isExpanded ? 'Close' : 'Open'}
      data-testid={`expanded-toggle-button-${id}`}
    >
      <ExpandMoreIcon
        sx={{
          transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shortest,
            }),
        }}
        fontSize="inherit"
      />
    </IconButton>
  );
}
